import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
// action types
export const UPDATE_TABLE_STRUCTURE = "getMYREPORTSTableStructure";
export const UPDATE_TABLE_DATA = "getMYREPORTSTableData";
export const EXPORT_TABLE_DATA = "exportMYREPORTSTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setMYREPORTSTableStructure";
export const SET_TABLE_DATA = "setMYREPORTSTableData";
export const SET_TABLE_FILTER = "setMYREPORTSTableFilter";
export const SET_TABLE_PAGE = "setMYREPORTSTablePage";
export const SET_TABLE_PERPAGE = "setMYREPORTSTablePerPage";
export const SET_TABLE_SORTBY = "setMYREPORTSTableSortBy";
export const SET_TABLE_SORTORDER = "setMYREPORTSTableSortOrder";
export const SET_EXPORT_LINK = "setMYREPORTSExportLink";

const state = {
  export_link: null,
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  getMYREPORTSTableState(state) {
    return state.table_state;
  },

  getMYREPORTSTableHeaders(state) {
    return state.table_structure.columns;
  },

  getMYREPORTSTableFilters(state) {
    return state.table_structure.filters;
  },

  getMYREPORTSTablePermissions(state) {
    return state.table_structure.permissions;
  },

  getMYREPORTSTableData(state) {
    return state.table_data.data;
  },

  getMYREPORTSTableProperties(state) {
    return state.table_structure.properties;
  },

  getMYREPORTSTableServices(state) {
    return state.table_structure.services;
  },

  getMYREPORTSExportUrl(state) {
    return state.export_link;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    return new Promise((resolve) => {
      ApiService.post("/settings/reports")
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/settings/reports/datatable", payload)
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);

          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/settings/reports/export", payload)
        .then(({ data }) => {
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
